<template>
  <div class="bq-product-qlcsl">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      全流程刷脸就医是指用户无需携带任何证件与手机，通过刷脸即可完成诊疗全流程。功能包括刷脸建档、挂号、缴费与核身，应用场景覆盖门诊挂号处、分诊台、就诊科室、检查检验签到处及取药处等。
    </p>
    <div class="qlcsl-descs">
      <div class="descs-left">
        <img
          style="width:234px; height: 692px;"
          src="https://img.alicdn.com/tfs/TB1X6D0FQL0gK0jSZFAXXcA9pXa-458-1380.png"
          alt=""
        />
      </div>
      <div class="descs-right">
        <img
          src="https://img.alicdn.com/tfs/TB14ufbDRr0gK0jSZFnXXbRRXXa-38-698.png"
          alt=""
        />
        <div class="descs-linetext">
          <div v-for="item in descs" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="qlcsl-adv">
      <InfoBox
        :col="2"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'qlcsl',
  data() {
    return {
      rightArrow:
        'https://img.alicdn.com/tfs/TB1VDuoDUY1gK0jSZFMXXaWcVXa-36-16.png',
      descs: [
        {
          title: '刷脸核身',
          desc:
            '用户门诊入院后，可通过院端自助机/刷脸屏，选择身份识别方式，进行入院登记操作，刷脸核身把患者的身份证号和刷脸信息核对，如果核对成功，则直接接诊，如果核身不成功，则提示人脸识别失败;',
        },
        {
          title: '刷脸挂号',
          desc:
            '居民通过人脸识别比对，核实身份，授权进行业务操作，进行挂号、预约挂号等操作;',
        },
        {
          title: '诊间刷脸接诊',
          desc: '选择刷脸功能，实现刷脸接诊病人，需要录入手机号，并授权；',
        },
        {
          title: '诊间刷脸核身',
          desc: '选择病人，点击刷脸，即可确认病人身份;',
        },
        {
          title: '诊间刷脸结算',
          desc:
            '自费用户通过刷脸实现结算，访问到蚂蚁金服的对外开发平台进行确认。',
        },
      ],
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1rsN7F1L2gK0jSZPhXXahvXXa-88-66.png',
          advTitles: '实名制',
          advDesc:
            '实现实名制就医，确保患者就诊信息的完整性、真实性、唯一性和连贯性，让诊疗信息完整地录入院内档案，有利于院内患者档案统一管理。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB10WnrbicKOu4jSZKbXXc19XXa-86-74.png',
          advTitles: '无纸化',
          advDesc:
            '国内第一家提供刷脸就医结合电子健康卡（推动医院取消实体就诊卡）的全流程解决方案的公司。推动实现院内无纸化。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1YTCaF2b2gK0jSZK9XXaEgFXa-88-88.png',
          advTitles: '解放双手',
          advDesc:
            '就医全流程都可通过 “刷脸” 实现核身并完成支付。患者就诊，不再需要手忙脚乱找身份证、银行卡，甚至手机，抱着孩子的家长也可以单手完成操作，解放患者双手。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1bA5iFYj1gK0jSZFuXXcrHpXa-88-88.png',
          advTitles: '一次到底',
          advDesc: '支持“刷脸” 开通信用就医，实现诊疗费用“最多付一次”。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-qlcsl {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .qlcsl-descs {
    display: flex;
    justify-content: center;
    padding-top: 54px;
    padding-bottom: 90px;
    color: #333;

    .descs-left {
      margin-left: 80px;
      margin-right: 120px;
    }

    .descs-right {
      display: flex;
      img {
        margin-right: 40px;
        min-width: 38px;
        max-height: 698px;
      }

      .descs-linetext {
        div {
          h3 {
            font-size: 20px;
            margin-bottom: 15px;
          }
          p {
            font-size: 16px;
          }
          &:nth-child(2) {
            margin-bottom: 45px;
          }
          &:nth-child(3) {
            margin-bottom: 45px;
          }
          &:nth-child(4) {
            margin-bottom: 65px;
          }
          &:last-child {
            margin-bottom: 0px;
          }
          &:first-child {
            margin-top: 20px;
            margin-bottom: 30px;
          }
        }
      }
    }
  }

  .qlcsl-adv {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .bq-infobox {
      width: 400px !important;
      margin-bottom: 60px;
      &:nth-child(3),
      &:nth-child(4) {
        margin-bottom: 0;
      }
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    padding-bottom: 0;
    margin-bottom: 60px;
  }
}
</style>
